import api from "Helpers/Api";
import { ProductRequestList } from "Services/Ad/Product/product";
import { IAd } from "Services/Ad/ad";
import { IPagination } from "Services/pagination";

export default async function productsList({
  page,
  perPage,
  search,
  categories,
  subcategories,
  vehicles = false,
  published,
  undefinedPrices = true,
  ...rest
}: ProductRequestList) {
  const arr = categories?.split(",").map(c => c.trim()) ?? [];

  if (arr.length > 0 && arr.every(item => item.includes("vazio"))) {
    return {
      data: [],
      total: "0",
      sort: "",
      order: "asc",
    } as any;
  } else {
    categories = arr.filter(item => !item.includes("vazio")).join(",");
    const { data } = await api.get<IPagination<IAd>>("/products/", {
      params: {
        search,
        categories,
        page,
        perPage,
        subcategories,
        vehicles,
        published,
        undefinedPrices,
        ...rest,
      },
    });
    const now = new Date().getTime();
    data.data = data.data
      .map(item => {
        const start = item.highlight_start_at
          ? new Date(item.highlight_start_at).getTime()
          : null;
        const end = item.highlight_expires_at
          ? new Date(item.highlight_expires_at).getTime()
          : null;

        const isHighlighted =
          start !== null && end !== null && now >= start && now <= end;

        return {
          ...item,
          isHighlighted,
        };
      })
      .sort((a, b) => {
        if (a.isHighlighted && !b.isHighlighted) return -1;
        if (!a.isHighlighted && b.isHighlighted) return 1;
        const aTime = a.highlight_start_at
          ? new Date(a.highlight_start_at).getTime()
          : 0;
        const bTime = b.highlight_start_at
          ? new Date(b.highlight_start_at).getTime()
          : 0;

        return bTime - aTime;
      });

    return data;
  }
}
